import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import Button from 'components/button/button';
import Modal from 'components/modal';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 10px 5px 5px 5px;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 50px;
  width: 100%;
  margin-top: ${props => props.marginTop};
  margin-bottom: 5px;
`;

const ButtonText = styled.div`
  width: 100%;
  height: 50px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF;
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #333;
`;

const SettingsNote = styled.div`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #777;
  font-style: italic;
`;

@observer
class TriviaOpponentsModal extends React.Component {
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <Modal
        onCloseModal={this.props.onCloseModal}
        top={AppUI.layout.isMobile ? '60px' : '100px'}
        width={AppUI.layout.isMobile ? '90%' : AppUI.layout.defaultModalWidth}
        gradient
        title='Trivia Settings'
      >
        <ModalContent>
          <Description>
            <div>{this.props.description}</div>
          </Description>
          <ButtonRow>
            <ButtonWrapper>
              <Button
                height='50px'
                width='100%'
                background={Theme.blue}
                onClick={this.props.onSelectPlayWithOpponents}
                alignItems='center'
              >
                <ButtonText>
                  Play Against Others
                </ButtonText>
              </Button>
            </ButtonWrapper>
            <ButtonWrapper
              marginTop='10px'
            >
              <Button
                height='50px'
                width='100%'
                background={Theme.blue}
                onClick={this.props.onSelectPlaySolo}
                alignItems='center'
              >
                <ButtonText>
                  Play Solo
                </ButtonText>
              </Button>
            </ButtonWrapper>
          </ButtonRow>
          <SettingsNote>
            {this.props.settingsNote}
          </SettingsNote>
        </ModalContent>
      </Modal>
    );
  }
}

export default TriviaOpponentsModal;

